<template>
  <form @submit.prevent="onSubmit()">
    <b-loading :is-full-page="true" :active.sync="saving"></b-loading>
    <div class="row mb-2">
      <div class="col-12">
        <b-checkbox v-model="campaign.active">Ativo</b-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-lg-6">
        <app-input
          label="Nome da campanha"
          required
          v-model="campaign.name"
          :errors="errors.name"
        ></app-input>
      </div>
      <div class="col-sm-6 col-lg-3">
        <b-field label="Inicia em" required>
          <b-datepicker
            v-model="campaign.start_at"
            :errors="errors.start_at"
            :years-range="[-100, 100]"
            :date-formatter="bDateFormatter"
            placeholder="Selecionar data..."
            icon="calendar-today"
            trap-focus
          ></b-datepicker>
        </b-field>
        <span class="error-alert" v-if="errors.start_at"
          >O campo de data é obrigatório</span
        >
      </div>

      <div class="col-sm-6 col-lg-3">
        <b-field label="Termina em" required>
          <b-datepicker
            :disabled="campaign.start_at == null"
            :min-date="campaign.start_at"
            :years-range="[-100, 100]"
            v-model="campaign.end_at"
            :errors="errors.end_at"
            :date-formatter="bDateFormatter"
            placeholder="Selecionar data..."
            icon="calendar-today"
            trap-focus
          ></b-datepicker>
        </b-field>
        <span class="error-alert" v-if="errors.end_at"
          >O campo de data é obrigatório</span
        >
      </div>
    </div>
    <div class="row mt-2"></div>
    <div class="row">
      <div class="col-sm-6 col-lg-6">
        <app-file-picker
          v-model="imageToCrop"
          flag="campaign"
          label="Imagem"
          accept="image/*"
          @fileDeleted="() => (this.campaign.image = '')"
          required
        ></app-file-picker>

        <app-image-cropper
          v-if="imageToCrop"
          :src="imageToCrop"
          :aspectRatio="16 / 9"
          @croppedImage="onCropperImage"
        ></app-image-cropper>

        <img
          v-if="campaign.image"
          :src="campaign.image"
          alt="Imagem da Campanha"
          class="image-preview"
        />

        <br />
        <br />
        <span class="error-alert" v-if="errors.image && !campaign.image"
          >É obrigatório o envio de uma imagem</span
        >
      </div>
      <div class="col-sm-3">
        <app-network-select
          v-model="campaign.networks_id"
          :errors="errors.networks_id"
        ></app-network-select>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12">
        <b-field label="Texto" required>
          <editor
            v-model="campaign.text"
            :errors="errors.text"
            :api-key="tynemceApiKey"
            :init="tynemceConfig"
          />
        </b-field>
        <span class="error-alert" v-if="errors.text">{{ errors.text[0] }}</span>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <button type="submit" :disabled="saving" v-app-button>Salvar</button>
      </div>
    </div>
  </form>
</template>

<script>
import CampaignService from '@/services/campaign.service';
import BuefyMixin from '@/mixins/BuefyMixin';
import Editor from '@tinymce/tinymce-vue';
import { required } from 'vuelidate/lib/validators';
import { TYNEMCE } from '@/constants/tinymce.constants';
import * as moment from 'moment';

import AppImageCropper from '@/components/AppComponents/AppCropperImage.vue';

export default {
  name: 'campaign-form',
  mixins: [BuefyMixin],
  props: ['id', 'errors', 'saving'],
  components: { Editor, AppImageCropper },
  data: () => {
    return {
      imageToCrop: null,
      tynemceApiKey: TYNEMCE.API_KEY,
      tynemceConfig: {
        height: 300,
        menubar: false,
        plugins: TYNEMCE.PLUGINS,
        toolbar: TYNEMCE.TOOLBAR,
      },
      loading: true,
      campaign: {
        active: true,
        name: null,
        start_at: null,
        end_at: null,
        text: null,
        image: null,
        networks_id: [],
      },
      validations() {
        return {
          campaign: {
            name: { required },
            start_at: { required },
            end_at: { required },
            text: { required },
            image: { required },
            networks_id: { required, minLength: 1 },
          },
        };
      },
    };
  },
  methods: {
    loadCampaign(id) {
      CampaignService.getId(id)
        .then(({ data: campaign }) => {
          this.campaign = {
            ...campaign,
            start_at: new Date(campaign.start_at),
            end_at: new Date(campaign.end_at),
          };
        })
        .catch(() => this.toastfy('Erro ao carregar Campanha.', 'error'))
        .finally(() => (this.loading = false));
    },
    onSubmit() {
      this.loading = true;

      this.$emit('submit', {
        ...this.campaign,
        start_at: moment(this.campaign.start_at).format('DD/MM/YYYY'),
        end_at: moment(this.campaign.end_at).format('DD/MM/YYYY'),
      });
    },
    onCropperImage(value) {
      this.campaign.image = value;
      this.imageToCrop = '';
    },
  },
  beforeMount() {
    if (this.id) this.loadCampaign(this.id);
    else this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.error-alert {
  font-size: 0.8em;
  color: #ff6363;
  position: relative;
  top: -16px;
}

.message {
  font-style: italic;
  color: var(--color-danger);
  background: none;
}

.image-preview {
  max-height: 400px;
}
</style>
